// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { StudentInventoryCategory } from './StudentInventoryCategory'
import {
  StudentInventoryCategoryFromJSON,
  StudentInventoryCategoryFromJSONTyped,
  StudentInventoryCategoryToJSON,
} from './StudentInventoryCategory'

/**
 *
 * @export
 * @interface StudentPurchaseRequest
 */
export interface StudentPurchaseRequest {
  /**
   *
   * @type {string}
   * @memberof StudentPurchaseRequest
   */
  eventId?: string
  /**
   *
   * @type {string}
   * @memberof StudentPurchaseRequest
   */
  id?: string
  /**
   *
   * @type {StudentInventoryCategory}
   * @memberof StudentPurchaseRequest
   */
  category?: StudentInventoryCategory
}

/**
 * Check if a given object implements the StudentPurchaseRequest interface.
 */
export function instanceOfStudentPurchaseRequest(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function StudentPurchaseRequestFromJSON(
  json: any,
): StudentPurchaseRequest {
  return StudentPurchaseRequestFromJSONTyped(json, false)
}

export function StudentPurchaseRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StudentPurchaseRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    eventId: !exists(json, 'eventId') ? undefined : json['eventId'],
    id: !exists(json, 'id') ? undefined : json['id'],
    category: !exists(json, 'category')
      ? undefined
      : StudentInventoryCategoryFromJSON(json['category']),
  }
}

export function StudentPurchaseRequestToJSON(
  value?: StudentPurchaseRequest | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    eventId: value.eventId,
    id: value.id,
    category: StudentInventoryCategoryToJSON(value.category),
  }
}
